import OrderAction from './orderAction';

export default class DownloadInvoicesAction extends OrderAction {
    static NAME = 'download_invoices';

    static is_available({ event, feature_flags, items }) {
        return items.length === 1;
    }

    // simple and global
    get is_direct() {
        return true;
    }

    get needs_confirm() {
        return false;
    }

    get needs_selection() {
        return false;
    }

    onActionDone() {
        this.onClose();
    }
}
